import { render, staticRenderFns } from "./Icon_group.vue?vue&type=template&id=1389ee2a&"
import script from "./Icon_group.vue?vue&type=script&lang=js&"
export * from "./Icon_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports